// test2941
(2941 && 0);
